import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch("https://readdy.ai/api/form/d7am8b1nauq9gnuqnlpg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#2c2016] text-[#e8ddd0] mt-0">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand + Newsletter */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-1 mb-4">
              <span className="font-bold text-xl text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Junk</span>
              <span className="font-black text-xl" style={{ fontFamily: "'Playfair Display', serif", color: "#f5c518" }}>4</span>
              <span className="font-bold text-xl text-white" style={{ fontFamily: "'Playfair Display', serif" }}>Journals</span>
            </div>
            <p className="text-sm text-[#a89880] leading-relaxed mb-6">
              The community directory for junk journal and snail mail creators. Discover, connect, and create.
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#c9a87c] mb-3">Stay Inspired</p>
            {submitted ? (
              <p className="text-sm text-[#c9a87c]">Thanks for subscribing! Welcome to the community.</p>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubscribe}
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="flex-1 bg-[#3d2e1e] border border-[#5a4535] rounded-full px-4 py-2 text-sm text-white placeholder-[#7a6555] focus:outline-none focus:border-[#c9a87c] min-w-0"
                  required
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-4 py-2 bg-[#c9a87c] text-[#2c2016] rounded-full text-sm font-semibold hover:bg-[#d4b88c] transition-colors whitespace-nowrap"
                >
                  {submitting ? "..." : "Subscribe"}
                </button>
              </form>
            )}
          </div>

          {/* Explore Links */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#c9a87c] mb-4">Explore</p>
            <div className="flex flex-col gap-3">
              {[
                { label: "Directory", path: "/catalog" },
                { label: "Categories", path: "/categories" },
                { label: "Featured Creators", path: "/featured" },
                { label: "Community Forums", path: "/forums" },
                { label: "Submit Your Info", path: "/submit" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-[#a89880] hover:text-[#e8ddd0] transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact & Social */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#c9a87c] mb-4">Get In Touch</p>
            <a href="mailto:cosoliver67@gmail.com" className="text-sm text-[#a89880] hover:text-[#c9a87c] transition-colors mb-1 block cursor-pointer">cosoliver67@gmail.com</a>
            <p className="text-sm text-[#a89880] mb-6">For creator inquiries & partnerships</p>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#c9a87c] mb-3">Follow Us</p>
            <div className="flex gap-4">
              {[
                { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com/junk4journals" },
                { icon: "ri-pinterest-line", label: "Pinterest", href: "https://www.pinterest.com/junk4journals" },
                { icon: "ri-facebook-circle-line", label: "Facebook", href: "https://www.facebook.com/junk4journals" },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center text-[#a89880] hover:text-[#c9a87c] transition-colors"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-[#3d2e1e] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#6b5a4a]">© 2026 Junk4Journals. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="mailto:hello@junk4journals.com" className="text-xs text-[#6b5a4a] hover:text-[#a89880] transition-colors">Contact Us</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
